import { ClockCircleOutlined } from '@ant-design/icons'
import moment from 'moment'
import Link from 'next/link'
import BASE_CONFIG from 'src/configs/base'
import { convertImagePath } from 'src/utils/common'

const RelavantNews = ({ data }) => {
	return (
		<div className="c-relavant__news">
			<div className="relavant__news-container">
				<div className="relavant__news-img">
					{/* eslint-disable-next-line @next/next/no-img-element */}
					<img src={convertImagePath(data.Thumb)} alt={data.Name} />
				</div>
				<div className="relavant__news-info">
					<Link
						href={`/tin-tuc/${data.CategorySlug}/${data.SEO.Slug || BASE_CONFIG.DEFAULT_SEO_SLUG}/${data.Id}`}
					>
							<h4>{data.Name}</h4>
					</Link>
					<span className="info-timestamp">
						<ClockCircleOutlined style={{ fontSize: 15, marginRight: 4 }} />
						{moment(data.CreatedDate).format('DD/MM/YYYY')}
					</span>
				</div>
			</div>
		</div>
	)
}

export default RelavantNews
